import { Component } from "vue-property-decorator";
import BaseView from "./libs/core/BaseView";


@Component
export default class App extends BaseView {
  render() {
    return (
      <x-div id="app" width="100vw" height="100vh" flex="row|center">
        <router-view/>
      </x-div>
    );
  }
}
